<script>
import { mapGetters } from 'vuex';
import { emitter } from 'shared/helpers/mitt';
import { BUS_EVENTS } from 'shared/constants/busEvents';

export default {
  data() {
    return {
      isShaking: false,
    };
  },
  computed: {
    ...mapGetters({
      notificationMetadata: 'notifications/getMeta',
    }),
    unreadCount() {
      if (!this.notificationMetadata.unreadCount) {
        return '';
      }

      return this.notificationMetadata.unreadCount < 100
        ? `${this.notificationMetadata.unreadCount}`
        : '99+';
    },
    isNotificationPanelActive() {
      return this.$route.name === 'notifications_index';
    },
  },
  mounted() {
    emitter.on(BUS_EVENTS.LIVE_NOTIFICATION_CREATED, this.shake);
  },
  beforeDestroy() {
    emitter.off(BUS_EVENTS.LIVE_NOTIFICATION_CREATED, this.shake);
  },
  methods: {
    shake() {
      // Drop the class first so a notification arriving mid-shake restarts it.
      this.isShaking = false;
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.isShaking = true;
        });
      });
    },
    onShakeEnd() {
      this.isShaking = false;
    },
    openNotificationPanel() {
      if (this.$route.name !== 'notifications_index') {
        this.$emit('openNotificationPanel');
      }
    },
  },
};
</script>

<template>
  <div class="mb-4">
    <button
      class="relative flex items-center justify-center w-10 h-10 p-0 my-2 rounded-lg text-slate-600 dark:text-slate-100 transition-all duration-150"
      :class="{
        'bg-woot-50 dark:bg-slate-800 text-woot-500': isNotificationPanelActive,
        'hover:bg-woot-50 dark:hover:bg-woot-500/10 hover:ring-1 hover:ring-inset hover:ring-woot-100 dark:hover:ring-woot-500/20 hover:text-slate-600 dark:hover:text-slate-100':
          !isNotificationPanelActive,
      }"
      @click="openNotificationPanel"
    >
      <fluent-icon
        icon="alert"
        :class="{
          'text-woot-500': isNotificationPanelActive,
          'notification-bell--shake': isShaking,
        }"
        @animationend.native="onShakeEnd"
      />
      <span
        v-if="unreadCount"
        class="text-black-900 bg-yellow-300 absolute -top-0.5 -right-1 text-xxs min-w-[1rem] rounded-full"
      >
        {{ unreadCount }}
      </span>
    </button>
  </div>
</template>

<style scoped>
.notification-bell--shake {
  animation: notification-bell-shake 0.6s ease-in-out;
  transform-origin: 50% 0;
}

@keyframes notification-bell-shake {
  0%,
  100% {
    transform: rotate(0);
  }

  15% {
    transform: rotate(16deg);
  }

  30% {
    transform: rotate(-14deg);
  }

  45% {
    transform: rotate(10deg);
  }

  60% {
    transform: rotate(-8deg);
  }

  75% {
    transform: rotate(4deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .notification-bell--shake {
    animation: none;
  }
}
</style>
